// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBvnZTVgXOxyuCYImfUGyMrHYXRbb6u6Z0",
  authDomain: "itghar-c02f7.firebaseapp.com",
  projectId: "itghar-c02f7",
  storageBucket: "itghar-c02f7.appspot.com",
  messagingSenderId: "735766316388",
  appId: "1:735766316388:web:93fc992ab9ce877f852671",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
export default auth;
